<app-toast />

<app-card-content [border]="false" [title]="'Anuidades'" [icon]="'pi pi-money-bill'">
    <div card-header class="flex items-center gap-2">
        <p-button label="Adicionar" icon="pi pi-plus" severity="primary" [appCan]="roleAnuidadesEditar" (onClick)="abrirNovo()" />
    </div>

    <!-- ── Filtros ── -->
    <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
        @if (isUsuarioBR()) {
            <app-filtro-campo label="Filtrar por UF">
                <div class="flex items-center gap-2 h-full">
                    <p-toggleswitch [ngModel]="filtrarPorUf()" (ngModelChange)="onFiltrarPorUfChange($event)" />
                    @if (mostrarSelectEstado()) {
                        <app-estado-select class="flex-1 min-w-0" [uf]="ufFiltro()" [removeBR]="true" (ufChange)="onEstadoChange($event)" />
                    }
                </div>
            </app-filtro-campo>
        }
        <app-filtro-campo label="Tipo">
            <p-select [options]="tipoOptions" [ngModel]="filtroTipo()" (ngModelChange)="filtroTipo.set($event)" optionLabel="label" optionValue="value" [appendTo]="'body'" styleClass="w-full" />
        </app-filtro-campo>
        <app-filtro-campo label="Código ou Descrição" [wide]="true" inputId="anuidades-filtro-texto">
            <input id="anuidades-filtro-texto" pInputText type="text" class="w-full" [ngModel]="filtro()" (ngModelChange)="filtro.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Ex.: A26 ou Anuidade..." />
        </app-filtro-campo>
    </app-filtros-bar>

    <div class="flex flex-col gap-5 pt-1 mb-10">
        <!-- Barra de status -->
        <div class="flex justify-between items-center gap-3">
            <div class="flex items-center gap-2">
                <span class="text-sm text-surface-400 dark:text-surface-500">
                    <span class="font-bold text-surface-700 dark:text-surface-200">{{ totalRecords() }}</span>
                    {{ totalRecords() === 1 ? 'registro' : 'registros' }}
                </span>
                @if (ufFiltro() && filtrarPorUf()) {
                    <span class="inline-flex items-center gap-1 bg-primary/10 dark:bg-primary/20 text-primary text-[10px] font-bold px-2.5 py-0.5 rounded-full tracking-wide">
                        <i class="pi pi-map-marker" style="font-size: 0.55rem"></i>
                        {{ ufFiltro() }}
                    </span>
                }
                @if (isUsuarioBR() && !filtrarPorUf()) {
                    <span class="inline-flex items-center gap-1 bg-surface-100 dark:bg-surface-700 text-surface-500 dark:text-surface-400 text-[10px] font-bold px-2.5 py-0.5 rounded-full tracking-wide">
                        <i class="pi pi-globe" style="font-size: 0.55rem"></i>
                        Todas as UFs
                    </span>
                }
            </div>
            <div class="flex items-center gap-2">
                <app-table-view-switcher [viewMode]="viewMode()" (viewModeChange)="viewMode.set($event)" />
            </div>
        </div>

        <!-- Loading -->
        @if (carregando()) {
            <div class="flex flex-col items-center justify-center py-20 gap-3">
                <i class="pi pi-spin pi-spinner text-3xl text-primary opacity-50"></i>
                <span class="text-xs text-surface-400 tracking-widest uppercase">Carregando</span>
            </div>

            <!-- View: Cards -->
        } @else if (viewMode() === 'card') {
            <app-card-sort-pills class="mb-4" [opcoes]="sortOpcoes" [(field)]="sortField" [(order)]="sortOrder" />
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <!-- Card estático de resumo -->
                @if (items().length > 0) {
                    <article class="resumo-card">
                        <div class="flex items-center gap-2 mb-3">
                            <i class="pi pi-chart-bar text-primary"></i>
                            <span class="font-semibold">Resumo</span>
                        </div>
                        <div class="space-y-2 text-sm">
                            <div class="flex justify-between">
                                <span class="text-muted-color">Registros</span>
                                <span class="font-semibold">{{ totalRecords() }}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="text-muted-color">Exibindo</span>
                                <span class="font-semibold">{{ exibindoLabel() }}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="text-muted-color">Anuidades</span>
                                <span class="font-semibold text-green-600">{{ resumoPagina().anuidades }}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="text-muted-color">Taxas</span>
                                <span class="font-semibold text-blue-600">{{ resumoPagina().taxas }}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="text-muted-color">Multas</span>
                                <span class="font-semibold text-orange-600">{{ resumoPagina().multas }}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="text-muted-color">Abrangência</span>
                                <span class="font-semibold">{{ filtrarPorUf() && ufFiltro() ? ufFiltro() : 'Todas as UFs' }}</span>
                            </div>
                        </div>
                    </article>
                }

                @for (item of items(); track item.id_tpdebito + (item.sg_uf ?? '')) {
                    <app-card-container (click)="abrirDetalhe(item.id_tpdebito)">
                        <!-- Topo: código + UF | valor -->
                        <div class="indicador-topo">
                            <div class="flex items-center gap-2 min-w-0">
                                <p-badge [value]="item.id_tpdebito" badgeSize="large" [severity]="tipoSeverity(item)" />
                                @if (item.sg_uf) {
                                    <span class="uf-pill">{{ item.sg_uf }}</span>
                                }
                            </div>
                            <div class="indicador-contagem">
                                @if (item.pf?.vr_debito) {
                                    <div class="indicador-valor text-primary">{{ item.pf!.vr_debito | currency: 'BRL' }}</div>
                                } @else {
                                    <div class="indicador-valor text-muted-color italic text-sm font-normal">Variável</div>
                                }
                                <div class="indicador-label">Valor PF</div>
                            </div>
                        </div>

                        <h3 class="indicador-titulo truncate mt-2" [pTooltip]="item.ds_debito">{{ item.ds_debito }}</h3>

                        <div class="mt-3 space-y-1">
                            <div class="flex justify-between text-xs">
                                <span class="text-muted-color">Vencimento PF:</span>
                                <span class="font-semibold text-surface-700 dark:text-surface-200">{{ (item.pf?.dt_vencimento | date: 'dd/MM/yyyy') || 'N/A' }}</span>
                            </div>
                            <div class="flex justify-between text-xs">
                                <span class="text-muted-color">Multa:</span>
                                <span class="font-semibold text-surface-700 dark:text-surface-200">{{ item.pe_multa != null ? item.pe_multa + '%' : 'N/A' }}</span>
                            </div>
                            <div class="flex justify-between text-xs">
                                <span class="text-muted-color">Juros (mês):</span>
                                <span class="font-semibold text-surface-700 dark:text-surface-200">{{ item.pe_juros != null ? item.pe_juros + '%' : 'N/A' }}</span>
                            </div>
                        </div>

                        <!-- Tipo + Ação -->
                        <div class="flex justify-between items-center mt-4 pt-3 border-t border-surface-200 dark:border-surface-700">
                            <p-tag [value]="tipoLabel(item)" [severity]="tipoSeverity(item)" styleClass="text-[11px]" />
                            <p-button icon="pi pi-arrow-right" [text]="true" [rounded]="true" size="small" pTooltip="Ver Detalhes" (onClick)="abrirDetalhe(item.id_tpdebito)" (click)="$event.stopPropagation()" />
                        </div>
                    </app-card-container>
                } @empty {
                    <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                        <i class="pi pi-inbox text-5xl mb-3"></i>
                        <span>Nenhuma anuidade encontrada.</span>
                        @if (filtro()) {
                            <span class="text-xs opacity-60 mt-1">Tente um termo diferente</span>
                        }
                    </div>
                }
            </div>

            <!-- View: Tabela -->
        } @else {
            <p-table [value]="items()" dataKey="id_tpdebito" [tableStyle]="{ 'min-width': '56rem' }" [sortField]="sortField()" [sortOrder]="sortOrder()" (onSort)="onSortChange($event)" [rowHover]="true" stripedRows>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="id_tpdebito" class="w-28">
                            <strong>Código</strong>
                            <p-sortIcon field="id_tpdebito" />
                        </th>
                        <th class="w-14"><strong>UF</strong></th>
                        <th pSortableColumn="ds_debito">
                            <strong>Descrição</strong>
                            <p-sortIcon field="ds_debito" />
                        </th>
                        <th pSortableColumn="in_anuidade" class="w-36">
                            <strong>Tipo</strong>
                            <p-sortIcon field="in_anuidade" />
                        </th>
                        <th class="w-24 text-right"><strong>Multa</strong></th>
                        <th class="w-24 text-right"><strong>Juros</strong></th>
                        <th class="w-36 text-right"><strong>Valor PF</strong></th>
                        <th class="w-28"><strong>Venc. PF</strong></th>
                        <th class="w-14 text-center"><strong>Ações</strong></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr class="cursor-pointer" (click)="abrirDetalhe(item.id_tpdebito)">
                        <td>
                            <p-badge [value]="item.id_tpdebito" badgeSize="xlarge" [severity]="tipoSeverity(item)" />
                        </td>
                        <td>
                            @if (item.sg_uf) {
                                <span class="uf-pill">{{ item.sg_uf }}</span>
                            } @else {
                                <span class="text-surface-300 dark:text-surface-600 text-xs">—</span>
                            }
                        </td>
                        <td>
                            <span class="text-sm text-surface-700 dark:text-surface-300">{{ item.ds_debito }}</span>
                        </td>
                        <td>
                            <p-tag [value]="tipoLabel(item)" [severity]="tipoSeverity(item)" styleClass="text-[11px]" />
                        </td>
                        <td class="text-right">
                            <span class="text-sm text-surface-600 dark:text-surface-400 tabular-nums">{{ item.pe_multa != null ? item.pe_multa + '%' : '—' }}</span>
                        </td>
                        <td class="text-right">
                            <span class="text-sm text-surface-600 dark:text-surface-400 tabular-nums">{{ item.pe_juros != null ? item.pe_juros + '%' : '—' }}</span>
                        </td>
                        <td class="text-right">
                            @if (item.pf?.vr_debito) {
                                <p-badge value="{{ item.pf!.vr_debito | currency: 'BRL' : 'symbol' : '1.2-2' }}" badgeSize="xlarge" class="p-badge-info" />
                            } @else {
                                <span class="text-surface-300 dark:text-surface-600 text-xs italic">Variável</span>
                            }
                        </td>
                        <td>
                            <span class="text-sm text-surface-600 dark:text-surface-400 tabular-nums">{{ (item.pf?.dt_vencimento | date: 'dd/MM/yyyy') || '—' }}</span>
                        </td>
                        <td class="text-center">
                            <p-button icon="pi pi-arrow-right" [text]="true" [rounded]="true" size="small" (onClick)="abrirDetalhe(item.id_tpdebito)" (click)="$event.stopPropagation()" pTooltip="Ver Detalhes" />
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="9" class="py-12 text-center text-sm text-surface-400 dark:text-surface-600 italic">Nenhuma anuidade encontrada.</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="footer">
                    <tr class="custom-table-footer">
                        <td colspan="4">
                            <strong>Total de Registros: {{ totalRecords() }}</strong>
                        </td>
                        <td colspan="2" class="text-right">
                            <strong>Exibindo: {{ exibindoLabel() }}</strong>
                        </td>
                        <td colspan="3" class="text-right">
                            <strong>{{ filtrarPorUf() && ufFiltro() ? 'UF: ' + ufFiltro() : 'Todas as UFs' }}</strong>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        }

        <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage() * pageSize()" [rows]="pageSize()" [totalRecords]="totalRecords()" [rowsPerPageOptions]="[10, 20, 50]" [appendTo]="'body'" styleClass="mt-2" />
    </div>
</app-card-content>
